import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Router} from '@angular/router';
import { RateService } from '../../services/rate.service';
import { RateListener } from '../../interface/rate-listener';
import { Rate } from '../../interface/rate';
import { DraftService } from '../../services/draft.service';
import { RateDetailComponent } from '../rate-detail/rate-detail.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { realTechnologyNames } from 'src/app/shared/constantes';

@Component({
    selector: 'app-rate',
    templateUrl: './rate.component.html',
    styleUrls: ['./rate.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class RateComponent implements OnInit, OnChanges {
    @Input() listener: RateListener;
    @Input() showMobilePromo = false;

    @Input() set access(val: any) {
        this._access = val;
        this.getRates();
    }

    @Input() set realtechnology(val: any) {
        if (val) {
            this._realtechnology = val;
            this.loaded = true;
            const found = this._realtechnology.findIndex( x => x.access.toUpperCase() === this.technologies.adsl.toUpperCase());
            // Solo tenemos una tecnologia
            if (this._realtechnology.length === 1) {
                // La seleccionamos
                this.selectTypeAccess(0);
            // Tenemos dos tecnologias pero una es ADSL
            } else if (this._realtechnology.length === 2 && found !== -1) {
                // Seleccionamos la otra por defecto y mostramos el boton de ADSL
                this.showAdslButton = true;
                this.selectTypeAccess(found === 0 ? 1 : 0 );
            // Tenemos muchas tecnologias y una es ADSL
            } else if (found !== -1) {
                // Mostramos boton ADSL
                this.showAdslButton = true;
            }
        }
    }

    public _access: any;
    public _realtechnology: any[] = [];
    public rates: Rate[] = [];
    public loaded = false;
    public alertTechnology: string;
    public router: string;
    public technologies = realTechnologyNames;
    public indexTypeAccessSelected = -1;
    public showAdslButton : boolean = false;

    constructor(
        protected rateService: RateService, 
        private _router: Router,
        private draftService: DraftService,
        private modalService: NgbModal
    ) {
        this.router = _router.url;
    }

    ngOnInit(): void {
        this.getRates();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.getRates();
    }

    selectTypeAccess(value) {
        this.indexTypeAccessSelected = parseInt(value, null);
        this.rates = [];
        this.alertTechnology = null;

        if (this._realtechnology[this.indexTypeAccessSelected].real === true) {
            this._access = this._realtechnology[this.indexTypeAccessSelected].name;
            this.getRates();
        } else {
            this.alertTechnology = this._realtechnology[this.indexTypeAccessSelected].access;
            this._access = null;
        }
    }

    getRates() {
        if (this._access) {
            let accessToService;
            if (Array.isArray(this._access)) {
                accessToService = this._access.join(',');
            } else {
                accessToService = this._access;
            }
            this.loaded = false;

            this.rateService.getRates(accessToService)
                .subscribe((data: any) => {
                    this.loaded = true;
                    this.rates = data.msg;
                });
        }
    }

    selectRate(rate: any) {
        this.listener.onSelectRate(rate);
        this.draftService.saveDraft();
    }

    thereIsOffer(rate: Rate, name : string) : boolean {
        return (rate && rate.offers && rate.offers.length && rate.offers[0][name]);
    }

    showAdslRate() {
        if (this._realtechnology && this._realtechnology.length) {
            const found = this._realtechnology.findIndex(x => x.access.toUpperCase() === this.technologies.adsl.toUpperCase())
            this.selectTypeAccess(found);
        }
    }

    evaluateShowMoreInfo(rate){
        if (rate.infoDetails && rate.infoDetails.length) {
            const modalRef = this.modalService.open(RateDetailComponent, {size: 'lg', centered: true});
            modalRef.componentInstance.rate = rate;
        } else if (rate.info_url) {
            window.open(rate.info_url, "_blank");
        }
    }

}
